import axios from "axios";

import PRODUCTION from "@/common/config";

const APIService = axios.create({
  baseURL: PRODUCTION ? "/api" : "/api",
  headers: PRODUCTION
    ? {}
    : {
      Authorization: "Token 95e380511a15a5ba90209f9533f3685d090c627f",
    },
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});

export default APIService;
